import { buildSubscriptionHref, STUDIO_RETURN_URL } from 'Pods/ThreeDStudio/Shared/UsageBodies/constants'

// threeDStudioAccessTier (Generator::SubscriptionState#tier) drives every AI-landing CTA.
// Tiers whose users can already generate -- active subscription, free-beta trial, or
// spendable credits -- skip the payment form and go straight to the studio, as does the
// trial-eligible tier (the studio starts the trial itself).
export const CREATE_TIERS = ['subscribed', 'in_free_beta', 'has_credits']

export function resolveGeneratorCtaHref({ tier, paymentFormUrl }) {
  if (CREATE_TIERS.includes(tier) || tier === 'eligible_for_trial') return STUDIO_RETURN_URL

  return buildSubscriptionHref(paymentFormUrl)
}
